export default "__VITE_ASSET__DTXAQKFk__"